import { render, staticRenderFns } from "./ChartComponentGlobal.vue?vue&type=template&id=2b398d43&scoped=true&"
import script from "./ChartComponentGlobal.vue?vue&type=script&lang=js&"
export * from "./ChartComponentGlobal.vue?vue&type=script&lang=js&"
import style0 from "./ChartComponentGlobal.vue?vue&type=style&index=0&id=2b398d43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b398d43",
  null
  
)

export default component.exports